import { GustoCallbackPayloadState } from '@common/neo.tax';

import { env } from '@neo.tax/shared/utils';

const GUSTO_REDIRECT = `${env.REACT_APP_BACKEND_BASE_URL}/third-party-tokens/gusto/callback`;

export const getGustoAuthUrl = ({
  companyId,
  errorRedirectUrl,
  successRedirectUrl,
  userId,
}: GustoCallbackPayloadState): string => {
  const state = encodeURIComponent(JSON.stringify({ userId, companyId, errorRedirectUrl, successRedirectUrl }));
  const redirectUri = encodeURIComponent(GUSTO_REDIRECT);
  return `${env.REACT_APP_GUSTO_URL}/oauth/authorize?client_id=${env.REACT_APP_GUSTO_CLIENT_ID}&redirect_uri=${redirectUri}&state=${state}&response_type=code`;
};
